exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.component--wrapper.component--wrapper__image-box-preview[data-v-50263306] {\n    width: 100%;\n}\n.component--wrapper.component--wrapper__image-box-preview img[data-v-50263306] {\n    width: inherit;\n}\n", ""]);

// exports
